
import { textToHTML } from "@/utilities/textToHtml";

/**
 * Replace <img> tags with SVG content dynamically using jQuery.
 *
 *
 * This function targets all <img> tags with the class 'svg' and replaces them.
 * It preserves the ID, class, and size attributes of the original <img> tag.
 */
const imgSvgs = /** @type {NodeListOf<HTMLImageElement>} */( document.querySelectorAll( 'img.svg' ) );
imgSvgs.forEach( function( img ) {
    const id = img.id;
    const classList = img.classList.toString();
    const url = img.src;
    const ext = url.split( '.' ).pop();
    if ( ext !== 'svg' ) return;

    fetch( url ).then( async ( res ) => {
        const svgString = await res.text();
        const svg = textToHTML( svgString );
        if ( !svg ) return;

        if ( id ) svg.id = id;
        if ( classList ) svg.setAttribute( 'class', classList );
        svg.classList.add( 'replace-svg' );
        const height = svg.getAttribute( 'height' );
        const width = svg.getAttribute( 'width' );
        if ( !svg.getAttribute( 'viewBox' ) && height && width ) {
            svg.setAttribute( 'viewBox', `0 0 ${height} ${width}` );
        }

        img.replaceWith( svg );
    } ).catch( e => {
        console.warn( e );
    } );
} );

/**
 * When an element with the back-to-top class is clicked, animate
 * the user to scroll them back to the top of the page.
 */
document.querySelector( '.back-to-top' )?.addEventListener( 'click', () => {
    document.documentElement.scrollTo( { top: 0, behavior: 'smooth' } );
} );

document.querySelectorAll( '.openform' ).forEach( element => {
    element.addEventListener( 'click', () => {
        const form = document.querySelector( '.footer-form' );
        if ( form ) {
            form.classList.remove( 'hidden' );
            gsap.fromTo( form, { opacity: 0, y: 50 }, { opacity: 1, y: 0, duration: 0.5, ease: 'power2.out' } );
        }
    } );
} );

document.addEventListener( "DOMContentLoaded", function() {
    document.getElementById( "footer-line" ).classList.remove( "hidden" );

    const paths = document.querySelectorAll( "#footer-line path" );
    paths.forEach( path => {
        gsap.fromTo( path, { drawSVG: "0%" }, { duration: 2, drawSVG: "100%" } );
    } );
} );


document.addEventListener( "DOMContentLoaded", function() {
    const fields = document.querySelectorAll( ".custom-file-upload" );
    fields.forEach( field => {
        const input = field.querySelector( "[type=file]" );
        const text = field.querySelector( ".custom-file-upload__text" );
        if ( !input || !text ) return;

        input.addEventListener( "change", function() {
            if ( input.files.length > 0 ) {
                text.textContent = input.files[0].name;
            } else {
                text.textContent = "Choose a file";
            }
        } );
    } );
} );
